import React, { useState, useRef } from "react";
import { Typography, TextField, Button } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { commentPost } from "./../../actions/posts";
import useStyles from "./style";
import "./style.css";

const CommentSection = ({ post }) => {
  const [comments, setComments] = useState(post?.comments);
  const [comment, setComment] = useState("");

  const classes = useStyles();
  const dispatch = useDispatch();
  const commentRef = useRef();

  const user = JSON.parse(localStorage.getItem("profile"));

  const handleClick = async () => {
    const finalComment = `${user.result.name}: ${comment}`;
    const newComments = await dispatch(commentPost(finalComment, post._id));
    setComments(newComments);
    setComment("");
    commentRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <div className={classes.commentOuterContainer}>
        {/* <div className="scrollbar-hidden"> */}
        <Typography gutterBottom variant="h4">
          Comments:
        </Typography>
        {/* </div> */}
        <div id="scrollbar-hidden" className={classes.commentsInnerContainer}>
          {comments.map((c, i) => (
            <Typography className={classes.p} key={i} gutterBottom variant="p">
              <strong>{c.split(":")[0]}:</strong>
              {c.split(":")[1]} <br />
            </Typography>
          ))}
          <div ref={commentRef} />
        </div>
        {user?.result?.name && (
          <div style={{ width: "70%" }}>
            <Typography gutterBottom variant="h6">
              Write a Comments
            </Typography>
            <TextField
              variant="outlined"
              label="Comment"
              multiline
              fullWidth
              rows={3}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
            <Button
              style={{ marginTop: "10px" }}
              fullWidth
              disabled={!comment}
              variant="contained"
              onClick={handleClick}
              color="primary"
            >
              Comment
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CommentSection;
